const MARKERS = [
  { id: "pm", x: 300, y: 196, label: "PM2.5", unit: "µg/m³", cat: "air" },
  { id: "co2", x: 352, y: 150, label: "CO₂", unit: "ppm", cat: "air" },
  { id: "tvoc", x: 268, y: 236, label: "TVOC", unit: "index", cat: "air" },
  { id: "pb", x: 142, y: 304, label: "Pb", unit: "µg/L", cat: "water" },
  { id: "no2", x: 176, y: 232, label: "NO₂", unit: "ppb", cat: "air" },
];
const CAT_FILL = { air: "#D7CFF0", water: "#A8DAD8" };

export const MistDefs = () => (
  <defs>
    <filter id="mist-blur" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="22" /></filter>
    <filter id="mist-wisp" x="-40%" y="-40%" width="180%" height="180%">
      <feTurbulence type="fractalNoise" baseFrequency="0.012" numOctaves="2" seed="7" result="n" />
      <feDisplacementMap in="SourceGraphic" in2="n" scale="38" />
      <feGaussianBlur stdDeviation="14" />
    </filter>
    <linearGradient id="scan-grad" x1="0" x2="1">
      <stop offset="0" stopColor="#A8DAD8" stopOpacity="0" />
      <stop offset="0.5" stopColor="#A8DAD8" stopOpacity="0.35" />
      <stop offset="1" stopColor="#A8DAD8" stopOpacity="0" />
    </linearGradient>
  </defs>
);

export const HouseOutline = ({ dim }) => (
  <g className="mist-outline" style={{ opacity: dim ? 0.45 : 1 }} fill="none" stroke="#163B30" strokeWidth="1.25" strokeLinejoin="round" strokeLinecap="round">
    <path d="M70 350 V190 L220 90 L370 190 V350 Z" />
    <path d="M70 190 H370" strokeOpacity="0.35" />
    <path d="M220 90 V350" strokeOpacity="0.2" strokeDasharray="3 5" />
    <path d="M70 270 H220" strokeOpacity="0.35" />
    <rect x="100" y="212" width="42" height="34" rx="1" strokeOpacity="0.6" />
    <rect x="256" y="212" width="42" height="56" rx="1" strokeOpacity="0.6" />
    <rect x="320" y="212" width="30" height="56" rx="1" strokeOpacity="0.6" />
    <path d="M118 296 h48 v12 h-48 z" strokeOpacity="0.6" />
    <path d="M160 296 v-16" strokeOpacity="0.6" />
    <path d="M172 232 h30 M172 240 h30" strokeOpacity="0.6" />
    <path d="M250 300 h86 v34 h-86 z" strokeOpacity="0.5" />
    <path d="M120 350 h30 v-20 h-30 z" strokeOpacity="0.5" />
  </g>
);

export const MistBlobs = ({ opacity }) => (
  <g style={{ opacity }} className="mist-blob">
    <ellipse className="mist-blob mist-drift-a" cx="200" cy="230" rx="130" ry="80" fill="#A8DAD8" fillOpacity="0.5" filter="url(#mist-wisp)" />
    <ellipse className="mist-blob mist-drift-b" cx="280" cy="180" rx="110" ry="60" fill="#D7CFF0" fillOpacity="0.55" filter="url(#mist-blur)" />
    <ellipse className="mist-blob mist-drift-c hidden sm:block" cx="150" cy="300" rx="100" ry="50" fill="#A8DAD8" fillOpacity="0.45" filter="url(#mist-blur)" />
    <ellipse className="mist-blob mist-drift-a hidden sm:block" cx="330" cy="280" rx="90" ry="48" fill="#EAF4EF" fillOpacity="0.8" filter="url(#mist-blur)" />
    <ellipse className="mist-blob mist-drift-b" cx="230" cy="140" rx="70" ry="38" fill="#D7CFF0" fillOpacity="0.4" filter="url(#mist-wisp)" />
  </g>
);

export const ScanPlane = ({ active }) => (
  <g className="mist-scan" style={{ transform: active ? "translateX(420px)" : "translateX(-60px)", opacity: active ? 1 : 0 }}>
    <rect x="-30" y="60" width="60" height="310" fill="url(#scan-grad)" />
    <line x1="0" y1="60" x2="0" y2="370" stroke="#163B30" strokeWidth="1" strokeOpacity="0.8" />
  </g>
);

export const Markers = ({ visible }) => (
  <>
    {MARKERS.map((m, idx) => (
      <g key={m.id} className="mist-marker" style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(6px)", transitionDelay: `${0.25 + idx * 0.18}s` }}>
        <circle cx={m.x} cy={m.y} r="10" fill={CAT_FILL[m.cat]} stroke="#163B30" strokeWidth="1.25" />
        <circle cx={m.x} cy={m.y} r="3" fill="#163B30" />
        <text x={m.x + 16} y={m.y - 2} fontFamily="'JetBrains Mono', monospace" fontSize="10.5" fill="#163B30">{m.label}</text>
        <text x={m.x + 16} y={m.y + 10} fontFamily="'JetBrains Mono', monospace" fontSize="9" fill="#163B30" fillOpacity="0.55">{m.unit}</text>
      </g>
    ))}
  </>
);
